// extracted by mini-css-extract-plugin
export var caption = "bJ_hk";
export var grey = "bJ_dq";
export var heading = "bJ_G";
export var image = "bJ_g";
export var left = "bJ_bL";
export var reverse = "bJ_dm";
export var right = "bJ_bX";
export var section = "bJ_d";
export var video = "bJ_gL";
export var videoContainer = "bJ_cz";
export var videoWrapper = "bJ_cB";